// Groups are free text ("Group 1", "Bus A"). These helpers keep one spelling per group on a
// booking, so "bus 2", "Bus  2" and "Bus 2" never become three different groups.

export function normaliseGroup(value) {
    return String(value ?? "").replace(/\s+/g, " ").trim();
}

// Reuses the existing spelling of a group when one matches, ignoring case
export function canonicalGroup(value, existingGroups) {
    const group = normaliseGroup(value);
    if (!group) return "";
    return existingGroups.find((existing) => existing.toLowerCase() === group.toLowerCase()) || group;
}

const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

// Natural order, so "Group 2" sorts before "Group 10"
export function compareText(a, b) {
    return collator.compare(String(a ?? ""), String(b ?? ""));
}

export function groupsOf(rows) {
    const groups = [];
    (rows || []).forEach((row) => {
        const group = normaliseGroup(row.group);
        if (group && !groups.some((existing) => existing.toLowerCase() === group.toLowerCase())) {
            groups.push(group);
        }
    });
    return groups.sort(compareText);
}
